import React, { useContext, useEffect, useState } from 'react';
import { oneOfType, string, number } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Details } from './Details';

export const DetailsContainer = ({ timeout, ...props }) => {
  const { channel } = useContext(ExperienceContext);
  const { isCustomerIdentified = false } = useThdCustomer();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const defaultVariables = {
    lat: '',
    lng: '',
    pagesize: '10',
    searchTerm: null,
    sortBy: 'photoreview',
    startIndex: 1,
    recfirstpage: '10',
    storeFeaturesFilter: {
      applianceShowroom: false,
      expandedFlooringShowroom: false,
      wiFi: false,
      keyCutting: false,
      loadNGo: false,
      propane: false,
      toolRental: false,
      penske: false
    },
    filters: {
      ageRange: null,
      gender: null,
      isVerifiedPurchase: false,
      profile: null,
      prosCons: null,
      starRatings: null
    },
    isBrandPricingPolicyCompliant: isMounted ? isCustomerIdentified : false,
  };

  const queryOptions = ({ options, queryName }) => {

    if (queryName === 'storeSearch') {
      return {
        ...options,
        variables: {
          ...options.variables,
          pagesize: '10',
        },
      };
    }

    return options;
  };

  return (
    <QueryProvider
      queryOptions={queryOptions}
      cacheKey={`store-details-${channel}`}
      defaultVariables={defaultVariables}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Details {...props} />
    </QueryProvider>
  );
};

DetailsContainer.propTypes = {
  timeout: oneOfType([string, number])
};

DetailsContainer.defaultProps = {
  timeout: '3000'
};
